import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const FeatureSection = ({ reverse, eyebrow, title, body, bullets, cta, image }) => {
  return (
    <section className="bg-black py-24">
      <div className="max-w-[1480px] mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className={`relative h-[460px] flex items-center justify-center ${reverse ? 'lg:order-2' : ''}`}>
          <div className="absolute inset-0" style={{
            background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.15) 0%, rgba(0,0,0,0) 65%)'
          }} />
          <img src={image} alt={title} className="relative max-h-[420px] w-auto object-contain rounded-md" />
        </div>
        <div className="max-w-xl">
          <p className="text-[#d4af37] tracking-[0.35em] text-xs uppercase mb-4">{eyebrow}</p>
          <h2 className="serif-italic gold-gradient-text text-4xl md:text-5xl leading-tight">{title}</h2>
          <p className="mt-6 text-zinc-300 leading-relaxed">{body}</p>
          <ul className="mt-6 space-y-2">
            {bullets.map((b) => (
              <li key={b} className="text-zinc-200"><span className="text-[#d4af37] mr-2">✔</span>{b}</li>
            ))}
          </ul>
          <Link to={cta.href}><Button className="btn-gold mt-8 px-8 h-12 tracking-wider uppercase text-[14px]">{cta.label}</Button></Link>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
